import Vue from 'vue';
import Router from 'vue-router';
import store from '../store';
import {isActiveToken} from '../mixins/auth';
import Login from "../views/Login/Login";
import Home from "../views/Home/Index";
import OrdersList from "../views/Orders/List";
import Settings from "../views/Settings/Settings";
import ExchangeSettings from "../views/Settings/ExchangeSettings";
import UsersList from "../views/Users/List";
import ClaimsList from "../views/Claims/List";
import ExchangeStats from "../views/Stats/ExchangeStats.vue";
import Finished from "../views/Stats/Finished";
import BlackListUsers from "../views/BlackList/Users";
import BlackListRequisites from "../views/BlackList/Requisites";
import Service from "../views/Service/Service";
import ActionsStats from "../views/Stats/Actions";
import InterBanks from "../views/Settings/InterBanks.vue";
import cfg from '../store/config';
import DeeplinkAndQr from '../views/Settings/DeeplinkAndQr.vue';


Vue.use(Router);

const ifAuthenticated = (to, from, next) => {
  const role = store.getters['user/getRole'];
  if (role && to.meta && to.meta.access) {
    const defaultRoute = '/orders';
    if (!to.meta.access.includes(role)) {
      next(defaultRoute);
      return;
    }
  }
  if (isActiveToken(store.getters['user/getToken'])) {
    next();
    return;
  }
  next('/login');
};

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'Home',
      beforeEnter: ifAuthenticated,
      component: Home,
      children: [
        {
          path: '',
          beforeEnter: ifAuthenticated,
          component: OrdersList,
          meta: {
            access: ['admin', 'superadmin', 'partner', 'support'],
            title: 'Заявки',
          }
        },
        {
          path: 'orders',
          name: 'OrdersList',
          beforeEnter: ifAuthenticated,
          component: OrdersList,
          meta: {
            access: ['admin', 'superadmin', 'partner', 'support'],
            title: 'Заявки',
          }
        },
        {
          path: 'users',
          name: 'UsersList',
          beforeEnter: ifAuthenticated,
          component: UsersList,
          meta: {
            access: ['superadmin'],
            title: 'Пользователи',
          }
        },
        {
          path: 'settings',
          name: 'Settings',
          beforeEnter: ifAuthenticated,
          component: Settings,
          meta: {
            access: ['superadmin'],
            title: 'Настройки',
          }
        },
        {
          path: 'deeplink-qr-settings',
          name: 'DeeplinkAndQr',
          beforeEnter: ifAuthenticated,
          component: DeeplinkAndQr,
          meta: {
            access: ['superadmin'],
            title: 'Настройки Deeplink/QR',
          }
        },
        {
          path: 'exchange-settings',
          name: 'ExchangeSettings',
          beforeEnter: ifAuthenticated,
          component: ExchangeSettings,
          meta: {
            access: ['superadmin'],
            title: 'Настройка обменки',
          }
        },
        {
          path: 'interbanks',
          name: 'InterBanks',
          beforeEnter: ifAuthenticated,
          component: InterBanks,
          meta: {
            access: ['superadmin'],
            title: 'Внутребанк',
          }
        },
        {
          path: 'claims',
          name: 'ClaimsList',
          beforeEnter: ifAuthenticated,
          component: ClaimsList,
          meta: {
            access: ['superadmin', 'admin', 'support'],
            title: 'Претензии',
          }
        },
        {
          path: 'stats',
          name: 'ExchangeStats',
          beforeEnter: ifAuthenticated,
          component: ExchangeStats,
          meta: {
            access: ['superadmin', 'admin', 'partner'],
            title: 'Статистика',
          }
        },
        {
          path: 'finished',
          name: 'Finished',
          beforeEnter: ifAuthenticated,
          component: Finished,
          meta: {
            access: ['superadmin'],
            title: 'Завершенные',
          }
        },
        {
          path: 'blacklist-users',
          name: 'BlackListUsers',
          beforeEnter: ifAuthenticated,
          component: BlackListUsers,
          meta: {
            access: ['superadmin', 'admin', 'support'],
            title: 'ЧС клиенты',
          }
        },
        {
          path: 'blacklist-requisites',
          name: 'BlackListRequisites',
          beforeEnter: ifAuthenticated,
          component: BlackListRequisites,
          meta: {
            access: ['superadmin', 'admin', 'support'],
            title: 'ЧС реквизиты',
          }
        },
        {
          path: 'service',
          name: 'Service',
          beforeEnter: ifAuthenticated,
          component: Service,
          meta: {
            access: ['superadmin', 'admin'],
            title: 'Сервис',
          }
        },
        {
          path: 'stats-actions',
          name: 'ActionsStats',
          beforeEnter: ifAuthenticated,
          component: ActionsStats,
          meta: {
            access: ['superadmin', 'admin'],
            title: 'Мониторинг Активности',
          }
        },
      ],
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
      meta: {
        title: 'Авторизация',
      }
    },
  ],
});


let DEFAULT_TITLE = cfg.sitePrefix || '';
if (DEFAULT_TITLE) {
  DEFAULT_TITLE += ' - ';
}
router.afterEach((to, from) => {
  Vue.nextTick(() => {
    if (to.meta.title) {
      document.title = `${DEFAULT_TITLE}${to.meta.title}`;
    } else {
      if (DEFAULT_TITLE) {
        document.title = DEFAULT_TITLE;
      } else {
        document.title = 'Frontend';
      }
    }
  });
});

export default router;
